import { SPRITE_SYMBOLS } from "@/assets/icons/sprite/IconSprite";
import { SpriteIcon } from "@/assets/icons/sprite/SpriteIcon";

/* Sprite-backed: a rating draws five stars; the path lives in `IconSprite`. */
const EmptyStar = ({ className }) => {
  return (
    <SpriteIcon
      symbol={SPRITE_SYMBOLS.emptyStar}
      width="24"
      height="24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    />
  );
};

export default EmptyStar;
